import React from 'react';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { skeletonStyles } from '../blocks';

const containerStyles = css`
    background: ${colors.white.primary};
    border: 1px solid ${colors.greys.border};
    border-radius: 4px;
    padding: 16px;
`;

/** Skeleton shown in place of the Items table while a split parent's children load and none are cached. */
const OrderItemsLoading = () => (
    <div data-testid="order-items-loading" aria-busy="true" css={containerStyles}>
        <div css={[skeletonStyles, { width: '70%' }]} />
        <div css={[skeletonStyles, { width: '55%' }]} />
        <div css={[skeletonStyles, { width: '62%' }]} />
    </div>
);

export default OrderItemsLoading;
